// extracted by mini-css-extract-plugin
module.exports = {"title":"RideInfoTitle_title__1ITbe","ballSymbol":"RideInfoTitle_ballSymbol__1EIuX","routelink":"RideInfoTitle_routelink__3vsK0"};